import { Lead } from '@ospace/schemas'
import { API } from '@ospace/shared'
import { useQuery, UseQueryResult } from 'react-query'
import { Duration } from '@ospace/common'
import dayjs from 'dayjs'

type Opts = {
  clientId: number
  page: number
  limit: number
  duration: Duration
  search: any
  enabled?: boolean
}

export const useLeads = (opts: Opts): UseQueryResult<{ data: Lead[]; count: number }> => {
  const { clientId, page, limit, duration, search, enabled = true } = opts
  const startDate = duration?.segmentsDuration?.start
    ? dayjs(duration.segmentsDuration.start).format('YYYY-MM-DD')
    : undefined

  const endDate = duration?.segmentsDuration?.end
    ? dayjs(duration.segmentsDuration.end).format('YYYY-MM-DD')
    : undefined

  return useQuery({
    queryKey: ['client', clientId, 'leads', page, limit, startDate, endDate, search],
    queryFn: () =>
      API.get('client', `/clients/${clientId}/leads`, {
        queryStringParameters: { page, limit, startDate, endDate, search },
      }),
    keepPreviousData: true, // This is good for pagination
    enabled: enabled && !!startDate && !!endDate,
  })
}
